import { render, staticRenderFns } from "./importform.vue?vue&type=template&id=3ea46a8b&scoped=true&"
import script from "./importform.vue?vue&type=script&lang=js&"
export * from "./importform.vue?vue&type=script&lang=js&"
import style0 from "./importform.vue?vue&type=style&index=0&id=3ea46a8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea46a8b",
  null
  
)

export default component.exports